module.exports = __webpack_public_path__ + "media/application/images/ui/badge-peoples-choice-with-text-xs-e3c2e240671931b9003a317fb527a157.png";